import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { lastValueFrom } from 'rxjs';
import { VesselOwnershipTransfer } from 'icreate/common/models/vessel-ownership-transfer';

@Injectable({
    providedIn: 'root',
})
export class VesselOwnershipService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });
    private httpClientBackend;

    constructor(
        private http: HttpClient,
        private handler: HttpBackend
    ) {
        this.domain = EndPointApi.iApiDomain();
        this.httpClientBackend = new HttpClient(handler);
    }

    private currentOwnershipTransferId: string;

    getCurrentOwnershipTransferId() {
        return this.currentOwnershipTransferId;
    }

    setCurrentOwnershipTransferId(requestId: string) {
        this.currentOwnershipTransferId = requestId;
    }

    async getOwnershipTransfers(vesselId): Promise<VesselOwnershipTransfer[]> {
        return await lastValueFrom(
            this.http.get<VesselOwnershipTransfer[]>(`${this.domain}/api/ownership/transfers/${vesselId}`)
        );
    }

    async createOwnershipRequest(ownershipMail) {
        return await lastValueFrom(
            this.http.post(
                `${this.domain}/api/ownership/createRequest`,
                {
                    ownershipMail,
                    skipGuard: true,
                },
                {
                    headers: this.headers,
                }
            )
        );
    }

    async readOwnershipMessage(transferId: string) {
        return await lastValueFrom(
            this.http.put(
                `${this.domain}/api/ownership/transfer/read`,
                {
                    transferId,
                    skipGuard: true,
                },
                {
                    headers: this.headers,
                }
            )
        );
    }

    async claimVesselOwnership(ownershipData) {
        return await lastValueFrom(
            this.http.post(
                `${this.domain}/api/ownership/claim`,
                {
                    ownershipData,
                    skipGuard: true,
                },
                {
                    headers: this.headers,
                }
            )
        );
    }

    async changeVesselOwnership(ownershipData) {
        return await lastValueFrom(
            this.http.post(
                `${this.domain}/api/ownership/transfer`,
                {
                    ownershipData,
                    skipGuard: true,
                },
                {
                    headers: this.headers,
                }
            )
        );
    }

    async updateOwnershipTransferStatus(transferId: string, payload: any) {
        return await lastValueFrom(
            this.http.put(
                `${this.domain}/api/ownership/update`,
                {
                    transferId,
                    payload,
                    skipGuard: true,
                },
                {
                    headers: this.headers,
                }
            )
        );
    }
}
